export const filterValuesSeparator = '[.]';
